<template>
  <div id="app">
    <router-view />
    <!-- 侧栏 - 二维码 -->
    <div class="cd" v-if=" cdShow ">
      <div class="item">
        <div class="img-box">
          <img src="@/assets/images/app70.png" alt />
        </div>
        <p>手机扫码学习</p>
      </div>
      <div class="item">
        <div class="img-box">
          <img src="@/assets/images/portalSite/ewm.jpg" alt />
        </div>
        <p>微信公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
const themeObj = {
  version: require("element-ui/package.json").version,
  targeTheme: "#276a35",
  defaultStyle: "",
};
themeObj.url = `https://unpkg.com/element-ui@${themeObj.version}/lib/theme-chalk/index.css`;

export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    if (this._isMobile()) {
      window.location.href = "http://phone.hxpxxy.cn";
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (val.meta.theme) {
          this.getCSSString(themeObj.url, this.chalkHandler);
        } else {
          if (document.getElementById("chalk-style")) {
            document.getElementById("chalk-style").remove();
          }
        }
      },
      // immediate: true,
      // deep:true
    },
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 获取该版本默认主题色样式文件
    getCSSString(url, callback) {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          themeObj.defaultStyle = xhr.responseText.replace(
            /@font-face{[^}]+}/,
            ""
          );
          callback();
        }
      };
      xhr.open("GET", url);
      xhr.send();
    },
    // 获取默认主题色样式文件回调
    chalkHandler() {
      const defaultClusters = this.getThemeCluster("#409EFF".replace("#", ""));
      const newtClusters = this.getThemeCluster(
        themeObj.targeTheme.replace("#", "")
      );
      let newStyle = "";
      defaultClusters.forEach((color, index) => {
        themeObj.defaultStyle = themeObj.defaultStyle.replace(
          new RegExp(color, "ig"),
          newtClusters[index]
        );
      });
      newStyle = themeObj.defaultStyle;
      let styleTag = document.getElementById("chalk-style");
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.setAttribute("id", "chalk-style");
        document.head.appendChild(styleTag);
      }
      styleTag.innerText = newStyle;
    },
    // 生成配套主题色
    getThemeCluster(theme) {
      const tintColor = (color, tint) => {
        let red = parseInt(color.slice(0, 2), 16);
        let green = parseInt(color.slice(2, 4), 16);
        let blue = parseInt(color.slice(4, 6), 16);

        if (tint === 0) {
          // when primary color is in its rgb space
          return [red, green, blue].join(",");
        } else {
          red += Math.round(tint * (255 - red));
          green += Math.round(tint * (255 - green));
          blue += Math.round(tint * (255 - blue));

          red = red.toString(16);
          green = green.toString(16);
          blue = blue.toString(16);
          return `#${red}${green}${blue}`;
        }
      };

      const shadeColor = (color, shade) => {
        let red = parseInt(color.slice(0, 2), 16);
        let green = parseInt(color.slice(2, 4), 16);
        let blue = parseInt(color.slice(4, 6), 16);

        red = Math.round((1 - shade) * red);
        green = Math.round((1 - shade) * green);
        blue = Math.round((1 - shade) * blue);

        red = red.toString(16);
        green = green.toString(16);
        blue = blue.toString(16);

        return `#${red}${green}${blue}`;
      };

      const clusters = [theme];
      for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
      }
      clusters.push(shadeColor(theme, 0.1));
      return clusters;
    },
  },
  computed: {
    cdShow() {
      if (this.$route.name == "projectVideo") {
        return false;
      }
      if (this.$route.name == "tjLogin") {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.cd {
  position: fixed;
  right: 5px;
  top: 38%;
  z-index: 99;
  .item {
    padding: 5px;
    background: #fff;
    margin-top: 10px;
    box-sizing: border-box;
    text-align: center;
    .img-box {
      width: 90px;
      height: 90px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      font-size: 14px;
      color: #666;
      padding-top: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue